var $ = jQuery;
window.__PUBLIC_PATH__ = drupalSettings.path.baseUrl + 'themes/custom/portaledellafamiglia/dist/vendors/bootstrap-italia/fonts'
